import React from "react";
import { MassUnit } from "../../../../../types/process/process.types";
import {
  InternalStorageRecord,
  StorageDataType,
  StorageEnvironment
} from "../../../../../types/prodcut-data-review/product-data.types";
import { StorageFormValues } from "../types/storageTable.types";

export const toFormValues = (r: InternalStorageRecord): StorageFormValues => ({
  id: r.id,
  name: r.name,
  dataType: r.dataType,
  environment: r.environment ?? "",
  warehouseName: r.warehouseName,
  storageTemperature: r.storageTemperature === "" ? "" : String(r.storageTemperature),
  warehouseSize: r.warehouseSize === "" ? "" : String(r.warehouseSize),
  weight: r.weight === "" ? "" : String(r.weight),
  weightUnit: r.weightUnit,
  electricity: r.electricity === "" ? "" : String(r.electricity),
  utilization: r.utilization === "" ? "" : String(r.utilization),
  storageDays: r.storageDays === "" ? "" : String(r.storageDays)
});

export const fromFormValues = (data: StorageFormValues): Partial<InternalStorageRecord> => ({
  name: data.name,
  dataType: data.dataType as StorageDataType,
  environment: data.environment as StorageEnvironment | "",
  warehouseName: data.warehouseName,
  storageTemperature: data.storageTemperature === "" ? "" : Number(data.storageTemperature),
  warehouseSize: data.warehouseSize === "" ? "" : Number(data.warehouseSize),
  weight: data.weight === "" ? "" : Number(data.weight),
  weightUnit: data.weightUnit as MassUnit,
  electricity: data.electricity === "" ? "" : Number(data.electricity),
  utilization: data.utilization === "" ? "" : Number(data.utilization),
  storageDays: data.storageDays === "" ? "" : Number(data.storageDays)
});

/** View-mode cell helper: shows "N/A" for Generic records, an em dash for empty values. */
export const dim = (
  val: number | "" | string | null | undefined,
  isGeneric: boolean,
  suffix = ""
): React.ReactNode => {
  if (isGeneric) return <span className="tw-text-muted-foreground/60 tw-italic">N/A</span>;
  if (val === "" || val == null) return <span className="tw-text-muted-foreground">—</span>;
  return (
    <span className="tw-font-mono">
      {val}
      {suffix}
    </span>
  );
};
